import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  floorByBlockCode: [],
  floorAssetsAndShapesData: [],
  isLoadingFloorByBlockCode: false,
  isLoading: false,
  error: null,
  blockLocationTypes: [],
  blockTypes: [],
};

export const getAllFloorsByBlockCode: any = createAsyncThunk(
  "content/getAllFloorsByBlockCode",
  async () => {
    const res = await axios.get(`/slpapp/AssetDisplayLevel`);

    const data = await res.data;
    return data;
  }
);

export const getBlockLocationTypes: any = createAsyncThunk(
  "content/getBlockLocationTypes",
  async () => {
    const res = await axios.get(`/slpapp/BlockLocationType`);

    const data = await res?.data;
    return data;
  }
);

export const getBlockTypes: any = createAsyncThunk(
  "content/getBlockTypes",
  async () => {
    const res = await axios.get(`/BlockType`);

    const data = await res?.data;
    return data;
  }
);

export const removeAssetFloor: any = createAsyncThunk(
  "content/removeAssetFloor",
  async ({ payload, assetCode }: any) => {
    const res = await axios.put(`/slpapp/Asset/RemoveAssetFloor`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      params: { assetCode },
    });

    const data = await res?.data;
    return data;
  }
);

export const rearrangeIndexing: any = createAsyncThunk(
  "content/rearrangeIndexing",
  async ({ payload }: any) => {
    const res = await axios.post(
      `/slpapp/BlockToFloor/RearrangeIndex`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res?.data;
    return data;
  }
);

export const floorSlice = createSlice({
  name: "floor",
  initialState,
  reducers: {
    /*     setFloorAssetsAndShapesData(state, action) {
      state.floorAssetsAndShapesData = action.payload;
    }, */
  },
  extraReducers: (builder) => {
    builder.addCase(getAllFloorsByBlockCode.pending, (state) => {
      state.isLoadingFloorByBlockCode = true;
    });
    builder.addCase(getAllFloorsByBlockCode.fulfilled, (state, action) => {
      state.isLoadingFloorByBlockCode = false;
      state.floorByBlockCode = action.payload;
    });
    builder.addCase(getAllFloorsByBlockCode.rejected, (state, action) => {
      state.isLoadingFloorByBlockCode = false;
      state.error = action.error.message;
    });

    builder.addCase(getBlockLocationTypes.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getBlockLocationTypes.fulfilled, (state, action) => {
      state.isLoading = false;
      state.blockLocationTypes = action.payload;
    });
    builder.addCase(getBlockLocationTypes.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getBlockTypes.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getBlockTypes.fulfilled, (state, action) => {
      state.isLoading = false;
      state.blockTypes = action.payload;
    });
    builder.addCase(getBlockTypes.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(rearrangeIndexing.pending, (state) => {});
    builder.addCase(rearrangeIndexing.fulfilled, (state, action) => {});
    builder.addCase(rearrangeIndexing.rejected, (state, action) => {
      state.error = action.error.message;
    });
  },
});

// export const { setFloorAssetsAndShapesData } = floorSlice.actions;

export default floorSlice.reducer;
